import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getDialogConfig() {
    return {
        custom: {
            [PALETTE_IDS.DIALOGS]: {
                Login: {
                    loginView: {
                        // "ios" and "native" for the context, because for Android the behaviour may be different
                        _iosnative_hide: true,
                    },
                    lastLoginTime: {
                        hide: false,
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.AUTO_CASHOUT_DIALOG]: {
                AC_BET_DATE_TEXT: COLOR.BRAND.FOREGROUND1,
                AC_STATUS_TEXT: COLOR.BRAND.FOREGROUND1,
                AC_PENDING_MESSAGE_LABEL_TEXT: COLOR.BRAND.FOREGROUND1,
                AC_BET_TITLE_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                AC_DIALOG_TITLE_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                AC_ACTIVE_RULE_CASHOUT_LABEL_TEXT: {
                    fontSize: FONT.SIZE_LARGE,
                },
                AC_ACTIVE_RULE_CASHOUT_AMOUNT_LABEL_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                AC_ACTIVE_RULE_LABEL_TEXT: {
                    fontSize: FONT.SIZE_SMALL,
                },
            },
            [PALETTE_IDS.BET_BASE_INFO]: {
                BET_SUSPENDED_NOTIFICATION_WARNING_TEXT: {
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
            },
            [PALETTE_IDS.COMBINATION_ODDS_POPUP]: {
                COMBINATION_ODDS_BG: COLOR.BRAND.BACKGROUND1,
                COMBINATION_ODDS_CLOSE_BUTTON: {
                    CLOSE_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                },
                COMBINATION_ODDS_HEADER_SHOW_SEPARATOR: false,
                COMBINATION_ODDS_HEADER_TITLE: {
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                    fontStyle: 'italic',
                    textTransform: 'uppercase',
                },
                COMBINATION_ODDS_TABLE: {
                    TABLE_HEADER_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        textTransform: 'uppercase',
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    },
                },
            },
            [PALETTE_IDS.LOGIN_DIALOG]: {
                LOGIN_DIALOG_REGISTER_BUTTON: {
                    SECONDARY_BUTTON_BORDER_COLOR: COLOR.BRAND.FOREGROUND2,
                    SECONDARY_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        fontWeight: FONT.WEIGHT_BOLD,
                        textTransform: 'uppercase',
                    },
                },
                CHANGE_PASSWORD_OK_BUTTON: {
                    SECONDARY_BUTTON_BORDER_COLOR: COLOR.BRAND.FOREGROUND2,
                    SECONDARY_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        fontWeight: FONT.WEIGHT_BOLD,
                        textTransform: 'uppercase',
                    },
                },
                LOGIN_DIALOG_FORGOT_DETAILS_TEXT: {
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                    color: COLOR.BRAND.FOREGROUND2,
                    fontSize: FONT.SIZE_MEDIUM,
                    textTransform: 'uppercase',
                    fontStyle: 'italic',
                },
            },
            [PALETTE_IDS.ALERT_DIALOG]: {
                ALERT_DIALOG_BG: COLOR.BRAND.BACKGROUND4,
            },
        },
    };
}
